import { notifyParent } from 'mailup-react-helpers'
import { PageHeader } from 'mailup-web-components'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'

import setMenuItem from 'Helpers/setMenuItem'
import { useNavigate } from 'react-router-dom'

const Header = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Import' }),
      url: '#',
      onClick: () => navigate('/recipients/import'),
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Status' }),
    },
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.New' }),

      onClick: () => navigate('/recipients/import'),
    },
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.Status' }),
      isActive: true,
    },
  ]

  useEffect(() => {
    setMenuItem('RecipientsImportChooseType')
  }, [])

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      title={intl.formatMessage({ id: 'Load.MailupCommon.Status' })}
    />
  )
}

export default Header
